import Helpers from "./Helpers";

class MobileMenu {
  constructor(selector) {
    this.mq = window.matchMedia('(max-width: 768px)');
    this.menu = document.querySelector(selector);

    if (this.menu && this.mq.matches) {
      this.init();
    }
  }

  init() {
    this.openMobileMenu();
    this.closeMobileMenu();
    this.resizeCheck();
    this.addPlus();
    this.openSubMenu();
    this.adminBar();
  }

  /**
   * Adds a plus right next to the item in the menu
   */
  addPlus() {
    const submenus = this.menu.querySelectorAll('.menu-item-has-children .sub-menu');

    if (submenus.length) {
      submenus.forEach(menu => {
        menu.insertAdjacentHTML('beforebegin', '<div class="firac-mobile-menu__menus__menu-item__plus">+</div>');
      });
    }
  }

  /**
   * It triggers an action to open a submenu
   */
  openSubMenu() {
    const icons = this.menu.querySelectorAll('.firac-mobile-menu__menus__menu-item__plus');

    if (icons.length) {
      icons.forEach(icon => {
        icon.addEventListener('click', event => {
          const el = event.currentTarget;
          const toOpen = el.closest('li').querySelector('.sub-menu');

          if (toOpen) {
            Helpers.slideToggle(toOpen, 300).then(() => {
              this.changeSubmenuSymbol(el);
            });
          }
        });
      });
    }
  }

  /**
   * Changing + for - and the other way around
   */
  changeSubmenuSymbol(selector) {
    if (selector.classList.contains('minus')) {
      selector.innerText = '+';
      selector.classList.remove('minus');
    } else {
      selector.innerText = '-';
      selector.classList.add('minus');
    }
  }

  scrollHandling() {
    document.documentElement.classList.toggle('menu-open');
  }

  /**
   * Opening the mobile menu
   */
  openMobileMenu() {
    const bars = document.querySelector('.main-header__top__mobile-opener .bars');
    const menu = document.querySelector('.firac-mobile-menu');

    if (bars) {
      bars.addEventListener('click', () => {
        Helpers.fadeIn(menu);

        this.scrollHandling();
      });
    }
  }

  /**
   * Closing the mobile menu
   */
  closeMobileMenu() {
    const close = document.querySelector('.firac-mobile-menu .close');
    const menu = document.querySelector('.firac-mobile-menu');

    if (close) {
      close.addEventListener('click', () => {
        Helpers.fadeOut(menu);

        this.scrollHandling();
      });
    }
  }

  /**
   * Handles the mobile menu when resizing the screen
   */
  resizeCheck() {
    window.addEventListener('resize', () => {
      const menu = document.querySelector('.firac-mobile-menu');

      Helpers.fadeOut(menu);

      if (menu.style.display === 'block') {
        this.adminBar();
      }
    });
  }

  /**
   * Pushes the menu if the Wordpress Admin Bar is active
   */
  adminBar() {
    const bar = document.querySelector('#wpadminbar');

    if (bar) {
      const height = bar.offsetHeight;
      const menu = document.querySelector('.firac-mobile-menu');
      menu.style.marginTop = height + 'px';
    }
  }
}

export default MobileMenu;
